import LaunchpadLayout from '@/routes/layouts/LaunchpadLayout';
import { loginPMSPageLoader, notFoundRedirectLoader } from '@/routes/loaders/auth-loaders';
import { clearLaunchpadAuth, requireLaunchpadAuth } from '@/routes/loaders/launchpad-auth-loaders';
import { v2PathRedirectLoader } from '@/routes/loaders/legacy-redirects';
import { lazy } from 'react';
import { replace, RouteObject } from 'react-router';

const LoginPage = lazy(() => import('@/routes/pages/auth/LoginPage'));
const FacilityAddPage = lazy(() => import('@/routes/pages/facility/add/FacilityAddPage'));

const LaunchpadLoginPage = lazy(() => import('@/routes/pages/launchpad/launchpad-login-page'));
const LaunchpadPage = lazy(() => import('@/routes/pages/launchpad/launchpad-page'));
const LaunchpadCompletePage = lazy(
  () => import('@/routes/pages/launchpad/launchpad-complete-page'),
);
const LaunchpadBranchInfoStep = lazy(
  () => import('@/routes/pages/launchpad/steps/branch-info/launchpad-branch-info-step'),
);
const LaunchpadRoomInfoStep = lazy(
  () => import('@/routes/pages/launchpad/steps/room-info/launchpad-room-info-step'),
);
const LaunchpadAccessControlStep = lazy(
  () => import('@/routes/pages/launchpad/steps/access-control/launchpad-access-control-step'),
);
const LaunchpadEzremsRoomInfoStep = lazy(
  () => import('@/routes/pages/launchpad/steps/ezrems-room-info/launchpad-ezrems-room-info-step'),
);
const LaunchpadFeeSettingStep = lazy(
  () => import('@/routes/pages/launchpad/steps/fee-setting/launchpad-fee-setting-step'),
);
const LaunchpadOperationInfoStep = lazy(
  () => import('@/routes/pages/launchpad/steps/operation-info/launchpad-operation-info-step'),
);
const LaunchpadPermissionStep = lazy(
  () => import('@/routes/pages/launchpad/steps/permission/launchpad-permission-step'),
);
const LaunchpadTermsAndLinksStep = lazy(
  () => import('@/routes/pages/launchpad/steps/terms-and-links/launchpad-terms-and-links-step'),
);
const LaunchpadReviewStep = lazy(
  () => import('@/routes/pages/launchpad/steps/review/launchpad-review-step'),
);

export const publicRoutes: RouteObject[] = [
  {
    path: 'login/pms',
    loader: loginPMSPageLoader,
    element: <LoginPage />,
  },
  {
    path: 'facility/add',
    element: <FacilityAddPage />,
  },

  // 런치패드: 외부 지점 담당자용 public 위저드 (MFMS와 경로·인증 체계 동일)
  {
    element: <LaunchpadLayout />,
    children: [
      {
        path: 'launchpad-login',
        element: <LaunchpadLoginPage />,
        loader: clearLaunchpadAuth,
      },
      {
        path: 'launchpad/:id/review',
        element: <LaunchpadReviewStep />,
        loader: requireLaunchpadAuth,
      },
      {
        path: 'launchpad/:id/complete',
        element: <LaunchpadCompletePage />,
        loader: requireLaunchpadAuth,
      },
      {
        path: 'launchpad/:id',
        element: <LaunchpadPage />,
        loader: requireLaunchpadAuth,
        children: [
          { path: 'branch-info', element: <LaunchpadBranchInfoStep /> },
          { path: 'room-info', element: <LaunchpadRoomInfoStep /> },
          { path: 'access-control', element: <LaunchpadAccessControlStep /> },
          { path: 'ezrems-room-info', element: <LaunchpadEzremsRoomInfoStep /> },
          { path: 'fee-setting', element: <LaunchpadFeeSettingStep /> },
          { path: 'operation-info', element: <LaunchpadOperationInfoStep /> },
          { path: 'permission', element: <LaunchpadPermissionStep /> },
          { path: 'terms-and-links', element: <LaunchpadTermsAndLinksStep /> },
        ],
      },
    ],
  },

  {
    path: 'members',
    loader: () => replace('/mangrover/manage'),
  },
  {
    path: 'login',
    loader: () => replace('/login/pms'),
  },
  {
    path: 'v2/*',
    loader: v2PathRedirectLoader,
  },
  {
    path: '*',
    loader: notFoundRedirectLoader,
  },
];
